import React from "react";

const Offer = () => {
  return (
    <div>
      <h2
        data-aos="zoom-in-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        className="text-3xl font-bold text-secondary text-center font-serif my-3"
      >
        Eid Bundle Offer :Apply Code : 12webeliyas
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <img
          data-aos="fade-right"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          src="https://i.ibb.co/bB2Pm5v/Untitled-1-copy-1.jpg"
          alt=""
        />
        <img
          data-aos="fade-left"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          src="https://i.ibb.co/fQ0CHq2/Eid-Bundle-offer.jpg"
          alt=""
        />
      </div>
      <div
        data-aos="zoom-in-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        className="my-5 text-center block mx-auto"
      >
        <h2 className="text-4xl font-bold ">Attention:Deal Zone</h2>
        <p className="text-lg font-semibold text-accent">
          Hurry Up ! Get Discount Up to 50%
        </p>
        <div className="block mx-auto">
          <img
            data-aos="flip-up"
            data-aos-offset="200"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            className="w-[420px] mx-auto"
            src="https://i.ibb.co/NYsP4pR/2.gif"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Offer;
